module.exports = __webpack_public_path__ + "img/1497357758.7af2bc4d.jpg";